import { MIDDLE_STYLE } from '@constants/responsive';
import React from 'react';
import RenderTimelineHeaderComponents from './RenderTimelineHeaderComponents';
import RenderGridBaseComponents from './RenderGridBaseComponents';

type Props = {};

const BookingDayTimelineTab = (props: Props) => {
  return (
    <div style={{ ...MIDDLE_STYLE }}>
      <div style={{ overflow: 'auto', height: '100%' }}>
        <RenderTimelineHeaderComponents />
        <RenderGridBaseComponents />
      </div>
    </div>
  );
};

export default BookingDayTimelineTab;
